import './Home.css';
import SEO from '../components/seo/SEO';


function Home() {


  return (
    <>
      <SEO
        title="Home | Lurscript"
        description="Lurscript is a company dedicated to minimize the impact of climate change and promote sustainability through innovative solutions and technologies."
      />

      <main className="homePage">
        <div>
          <h1>Welcome to Lurscript</h1>
        </div>
  
      </main>
    </>
  );
}

export default Home;
